// extracted by mini-css-extract-plugin
export default {"header":"ticketSeries_header__i36lx","header__text":"ticketSeries_header__text__VUOP9","header__addButtonText":"ticketSeries_header__addButtonText__gySUs"};